import MaterialIconButton from '@material-ui/core/IconButton';
import PropTypes from 'prop-types';
import React from 'react';
import useStyles from './IconButton.styles';

export const sizeEnum = {
  small: 'small',
  medium: 'medium',
};

const IconButton = ({ children, onClick, size, style, classes, className, disabled, ...materialProps }) => {
  const internalClasses = useStyles();

  return (
    <MaterialIconButton
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...materialProps}
      color="primary"
      disabled={disabled}
      style={style}
      size={size}
      onClick={onClick}
      classes={classes}
      className={className || internalClasses.content}>
      <span className={internalClasses.content}>{children}</span>
    </MaterialIconButton>
  );
};

IconButton.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  classes: PropTypes.shape(),
  onClick: PropTypes.func,
  size: PropTypes.oneOf(Object.values(sizeEnum)),
  style: PropTypes.shape(),
  disabled: PropTypes.bool,
};

IconButton.defaultProps = {
  className: undefined,
  classes: undefined,
  size: sizeEnum.small,
  style: undefined,
  onClick: () => undefined,
  disabled: false,
};

export default IconButton;
